import { Module } from 'vuex'
import clientService from '@/api/clientService'
import { getBookieRegions } from '@/api/oddsService'
import { PriceOutcome } from '@/types/client'
import type { Region } from '@/types/user'

function initialState() {
  return {
    isSending: false,
    lastSentPayload: null,
    lastResponse: null,
    error: null,
    isCollapseOpen: false,
    regions: [] as Region[],
  }
}

const oddsModule: Module<any, any> = {
  namespaced: true,

  state: initialState,

  mutations: {
    resetOddsStore(state) {
      state.lastResponse = null
      state.lastSentPayload = null
      state.error = null
    },

    setIsSending(state, status: boolean) {
      state.isSending = status
    },

    setLastSentPayload(state, payload: any) {
      state.lastSentPayload = payload
    },

    setLastResponse(state, response: any) {
      state.lastResponse = response
    },

    setError(state, error: any) {
      state.error = error
    },

    setCollapseOpen(state, value: boolean) {
      state.isCollapseOpen = value
    },

    setRegions(state, regions: Region[]) {
      state.regions = regions
    },
  },

  actions: {
    resetOddsStore({ commit }) {
      commit('resetOddsStore')
    },

    async sendComposeResponse({ commit }, { context, composeResponse }) {
      commit('setIsSending', true)
      commit('setLastSentPayload', composeResponse)
      commit('setError', null)

      try {
        const response: PriceOutcome[] =
          await clientService.getOdds(context, composeResponse)
        commit('setLastResponse', response)
      } catch (error) {
        console.error('Failed to send composeResponse:', error)
        commit('setError', error)
      } finally {
        commit('setIsSending', false)
      }
    },

    async fetchRegions({ commit }) {
      try {
        const regions = await getBookieRegions()
        commit('setRegions', regions)
      } catch (error) {
        console.error('Failed to fetch bookie regions:', error)
        commit('setError', error)
      }
    },
  },

  getters: {
    isSending: (state) => state.isSending,
    lastSentPayload: (state) => state.lastSentPayload,
    lastResponse: (state) => state.lastResponse,
    error: (state) => state.error,
    isCollapseOpen: (state) => state.isCollapseOpen,
    regions: (state) => state.regions,
  },
}

export default oddsModule